<template>
    <b-modal @hidden="fecharModal" size="xl" hide-footer :title="title + ' > Cadastrar'" v-model="showModal">
        <b-card class='mt-3' bg-variant="light">
            <b-form @submit.prevent="submitForm">
                <b-row>
                    <b-col md="12">
                        <LgFormInput :disabled="isViewMode" labelclass='pl-0' id="numeroProcesso" classFormGroup="p-0"
                            v-model="numeroProcesso" required type='number' label="Processo Número:*" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <LgFormTextarea :disabled="isViewMode" labelclass='pl-0' id="objeto" classFormGroup="p-0"
                            v-model="objeto" required label="Objeto:*" description=" " />
                    </b-col>
                    <b-col md='6'>
                        <LgFormTextarea :disabled="isViewMode" description=" " labelclass='pl-0' id="observacao"
                            classFormGroup="p-0" v-model="observacao" required label="Observação:*" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md='6'>
                        <LgFormTextarea description=" " :disabled="isViewMode" labelclass='pl-0' id="historico"
                            classFormGroup="p-0" v-model="historico" required label="Histórico:*" />
                    </b-col>
                    <b-col md='6'>
                        <LgFormTextarea description=" " :disabled="isViewMode" labelclass='pl-0' id="historico"
                            classFormGroup="p-0" v-model="localentrega" required label="Local de Entrega:*" />
                    </b-col>

                </b-row>
                <b-row>
                    <b-col cols="6">
                        <lg-form-select :disabled="isViewMode" :adicionarTodos="false" v-model="classificacao" :loadFunction="tipoCompraList"
                            labelFormGroupBind="Natureza da Demanda:*" label="descricao" description=" "
                            filterList="true" />

                    </b-col>
                    <b-col md='6'>
                        <LgFormInput labelclass='p-0' id="tipoRequisicaoCompra" v-model="tipoCompra.descricao"
                            label="Tipo de Contração:" :disabled="true" />

                    </b-col>
                </b-row>
            </b-form>
            <b-tabs>
                <b-tab title="Autorizações">
                    <b-row>
                        <b-col class="mt-2 d-flex justify-content-end">
                            <b-button v-if="Object.keys(autorizacao).length === 0 && !isViewMode"
                                @click="abrirFinderAutorizacoes" variant="primary" class="mb-2">
                                +
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-table :items="[autorizacao]" :fields="autorizacaoFields">
                        <template #cell(actions)="">
                            <b-button v-if="Object.keys(autorizacao).length > 0" @click="removerAutorizacao"
                                variant="danger" size="sm" :disabled="isViewMode">
                                <b-icon icon="trash" />
                            </b-button>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab title="Itens">
                    <b-table :items="itens" :fields="itensFields">
                        <template #cell(empresa)="data">
                            <LgFinderPageEmpresa
                                :disabled="isViewMode || tipoCompra.id == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod"
                                :prefix='[title]' classFormGroupBind='px-0 pt-2' v-model="data.item.empresa"
                                :id="'finderPageEmpresa' + data.index" label=" " cols="12" required />
                        </template>
                        <template #cell(quantidade)="data">
                            <b-form-input style="height: 20px;"
                                :disabled="isViewMode || tipoCompra.id == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod"
                                v-model="data.item.quantidade" type="number" min="1" required></b-form-input>
                        </template>
                        <template #cell(valorUnitario)="data">
                            <b-form-input style="height: 20px;"
                                :disabled="isViewMode || tipoCompra.id == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod"
                                v-model="data.item.valorUnitario" type="number" min="0" step="1"
                                required></b-form-input>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </b-card>
        <div class="d-flex justify-content-center mt-3">
            <b-button v-if="!isViewMode" id="confirmarSalvar" @click="submitForm" variant="success" style="height: 30px"
                pill size="sm">
                <div class="btn-size-alinhamento">
                    <b-icon icon="check-circle" />
                </div>
            </b-button>
            <b-button  v-if="!isViewMode" id="cancelar" class="ml-2" @click="fecharModal" style="height: 30px" pill
                size="sm" variant="danger">
                <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                </div>
            </b-button>
        </div>
        <LgFinderPageAutorizacoes :verificarOrcamento="false" :status="283" :consultaDetalhada='true' :modalOnly='true' id='finderAutorizacoes'
            :prefix='title' ref="finderAutorizacoes" @input="autorizacaoSelect" />
    </b-modal>

</template>

<script>
import LgFinderPageAutorizacoes from "@/components/Finders/LgFinderPageAutorizacoes.vue"
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue"
import { ListResourceMixin, FormResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import TipoRequisicaoCompraEnum from "@/core/utils/TipoRequisicaoCompraEnum"

export default {
    components: {
        LgFormInput,
        LgFormTextarea,
        LgFinderPageAutorizacoes,
        LgFinderPageEmpresa,
        LgFormSelect
    },
    props: {
        title: {
            type: Array,
            required: true,
            default: () => [],
        },
        idProcesso: {
            type: Number,
            default: null,
        },
        isViewMode: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [ListResourceMixin, FormResourceMixin],

    data() {
        return {
            TipoRequisicaoCompraEnum: TipoRequisicaoCompraEnum,
            tipoCompra: {},
            showModal: true,
            localentrega: "",
            numeroProcesso: "",
            dataCriacao: "",
            objeto: "",
            tipolocalCompra: "",
            observacao: "",
            historico: "",
            classificacao: { id: null },
            autorizacao: {},
            autorizacaoFields: [
                { key: 'autorizacaoNumero', label: 'Número' },
                { key: 'observacao', label: 'Descrição' },
                { key: 'actions', label: ' ' }
            ],
            itens: [],
            itensFields: this.isViewMode ? [
                { key: 'descricaoResumida', label: 'Nome' },
                { key: 'empresa', label: 'Empresa' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'quantidadeRetirada', label: 'Quantidade Retirada' },
                { key: 'porcentagemUtilizada', label: 'Porcentagem Retirada' },

                
                { key: 'valorUnitario', label: 'Valor' },
                { key: 'actions', label: ' ' }
            ] : [
                { key: 'descricaoResumida', label: 'Nome' },
                { key: 'empresa', label: 'Empresa' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'valorUnitario', label: 'Valor' },
                { key: 'actions', label: ' ' }
            ]
        }
    },
    methods: {

        async tipoCompraList({ filter, page = 1 }) {
            return await new ResourceService("/api/classificacao-tipo-compra").findAll({ filter, page, limit: 100 })
        },

        async fetchProcessoCompra() {
            if (this.idProcesso) {
                var { data } = await this.$service.get(this.idProcesso)
                const processoCompra = data
                this.numeroProcesso = processoCompra.numeroProcesso
                this.dataCriacao = processoCompra.dataCriacao
                this.objeto = processoCompra.objeto
                this.observacao = processoCompra.observacao
                this.historico = processoCompra.historico
                this.classificacao = processoCompra.classificacao
                this.autorizacao = processoCompra.autorizacao
                this.itens = processoCompra.itemProcessoCompra
                this.localentrega = processoCompra.localentrega;
                processoCompra.autorizacao.requisicoes.forEach(element => {
                    this.tipoCompra = element.tipoRequisicaoCompra;

                });

            }
        },
        fecharModal() {
            this.$emit("close")
        },
        abrirFinderAutorizacoes() {
            this.$refs.finderAutorizacoes.show()
        },
        async autorizacaoSelect(item) {
            this.autorizacao = item;
            this.tipoCompra = { id: item.tipoCompra, descricao: item.desricaoTipoCompra };
            this.busy = true;
            var { data } = await new ResourceService('/api/autorizacao-compra').get(`${item.id}/itens-para-processo-compra`);
            this.itens = data;
            this.busy = false;
        },
        removerAutorizacao() {
            this.autorizacao = {}
            this.itens = []
        },
        async submitForm() {
            if (!this.numeroProcesso) {
                this.$notify({
                    message: 'Por favor, preencha o campo Processo Número.',
                    type: 'danger',
                    solid: true
                })
                return
            }
            if (!this.objeto) {
                this.$notify({
                    message: 'Por favor, preencha o campo Objeto.',
                    type: 'danger',
                    solid: true
                })
                return
            }
            if (!this.observacao) {
                this.$notify({
                    message: 'Por favor, preencha o campo Observação.',
                    type: 'danger',
                    solid: true
                })
                return
            }
            if (!this.historico) {
                this.$notify({
                    message: 'Por favor, preencha o campo Histórico.',
                    type: 'danger',
                    solid: true
                })
                return
            }

            if (!this.localentrega || this.localentrega == "") {
                this.$notify({
                    message: 'Por favor, preencha o campo Local de Entrega.',
                    type: 'danger',
                    solid: true
                })
                return
            }

            if (!this.classificacao || !this.classificacao.id) {
                this.$notify({
                    message: 'Por favor, escolha uma classificação',
                    type: 'danger',
                    solid: true
                })
                return
            }

            for (const item of this.itens) {
                if (!item.empresa) {
                    this.$notify({
                        message: 'Por favor, preencha o campo Empresa para todos os itens.',
                        type: 'danger',
                        solid: true
                    })
                    return
                }
                if (!item.quantidade || item.quantidade <= 0) {
                    this.$notify({
                        message: 'Por favor, preencha o campo Quantidade para todos os itens.',
                        type: 'danger',
                        solid: true
                    })
                    return
                }
                if (item.quantidade > item.qtdMaxima) {
                    this.$notify({
                        message: `A quantidade do item ${item.descricaoResumida} não pode exceder ${item.qtdMaxima}.`,
                        type: 'danger',
                        solid: true
                    })
                    return
                }
                if (!item.valorUnitario || item.valorUnitario < 0) {
                    this.$notify({
                        message: 'Por favor, preencha o campo Valor para todos os itens.',
                        type: 'danger',
                        solid: true
                    })
                    return
                }
            }

            if (Object.keys(this.autorizacao).length === 0) {
                this.$notify({
                    message: 'Por favor, adicione uma autorizacao.',
                    type: 'danger',
                    solid: true
                })
                return
            }

            const processoCompra = {
                id: this.idProcesso,
                localentrega: this.localentrega,
                numeroProcesso: this.numeroProcesso,
                dataCriacao: this.dataCriacao,
                objeto: this.objeto,
                observacao: this.observacao,
                historico: this.historico,
                classificacao: this.classificacao,
                autorizacao: { id: this.autorizacao.id },
                itemProcessoCompra: this.itens,
            }

            try {

                await this.$saveResource(processoCompra, "", false, {}, false, true);

                this.fecharModal()
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });
            }

        }


    },

    beforeMount() {
        this.$service = new ResourceService("/api/processocompra");

        this.fetchProcessoCompra()
    }
}

</script>

<style scoped></style>
